var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"country-warpper"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":_vm.countryImg,"alt":""}})]),_c('div',{staticClass:"name-box",domProps:{"textContent":_vm._s(_vm.countryName)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }